<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.list{
  position: fixed;
  top: 160px;
  left: 0;
  right: 0;
  bottom: 150px;
  z-index: 2;
  overflow-y: auto;
}

.item{
  display: grid;
  grid-template-columns: 40px auto;
  color: white;
  margin: 10px 40px 0 40px;
  padding: 10px 0;
}
.check{
  grid-column: 1;
  text-align: center;
}
.text{
  grid-column: 2;
}

button.show-all{
  border: none;
  background-color: rgba(255,255,255,0.5);
  color: black;
  margin: 20px 0 0 80px;
  width: auto;
  font-size: 20px;
}
button.show-all:hover{
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
}

.sel{
  background-color: rgba(255,255,255,0.5);
  color: black;
}
</style>

<div class="bg">
  <div class="title-signup">Who are you looking to meet?</div>
  
  <div class="list">
    {#each lookingForOther as item}
      {#if showAllHelper(item, showAll)}
        <div class="item { sel.includes(item.t) ? 'sel' : '' }" on:click="{ () => selectHelper(item.t) }">
          <div class="check">
            
            {#if sel.includes(item.t)}
              <i class="icon-check"></i>
            {/if}
            
          </div>
          <div class="text">{item.t}</div>
        </div>
      {/if}
    {/each}
    
    {#if !showAll}
      <button class="show-all" on:click="{ () => showAll = true }">Show All Identities</button>
      
      <div class="margin small">Select all that apply</div>
    {/if}
    
    
  </div>
  
  <div class="has-buttons"></div>
</div>

<div class="next">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Genders from "../../../../helpers/Genders.js";
const lookingForOther = Genders.lookingForOther;

let showAll = false;
let sel = [];


function selectHelper(item) {
  let index = sel.indexOf(item);
  if (index != -1) {
    sel.splice(index, 1);
  } else {
    sel.push(item);
  }
  console.log("sel:", sel);
  sel = sel;
}


function showAllHelper(item) {
  if (showAll == false && item.d == true) {
    return true;
  } else if (showAll == true) {
    return true;
  }
  
  return false;
}


function next() {
  push("/signup/profile/personal/distance-away");
}


</script>